import { InvoicesDataViewContext } from "@insite/client-framework/Store/Data/Invoices/InvoicesSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import React, { FC, useContext } from "react";

export interface InvoiceHistoryResultCountStyles {
    invoiceCountText?: TypographyPresentationProps;
}

export const resultCountStyles: InvoiceHistoryResultCountStyles = {
    invoiceCountText: {
        color: "common.ui11",
        size: 18,
        weight: "bold",
    },
};

const styles = resultCountStyles;

const InvoiceHistoryResultCount: FC<WidgetProps> = () => {
    const invoicesDataView = useContext(InvoicesDataViewContext);

    if (!invoicesDataView.value || !invoicesDataView.pagination) {
        return null;
    }

    const { totalItemCount } = invoicesDataView.pagination;

    if (totalItemCount === 0) {
        return null;
    }

    return (
        <Typography {...styles.invoiceCountText} data-test-selector="invoiceHistory_resultCount">
            {totalItemCount} {totalItemCount > 1 ? translate("invoices") : translate("invoice")}
        </Typography>
    );
};

const widgetModule: WidgetModule = {
    component: InvoiceHistoryResultCount,
    definition: {
        group: "Invoice History",
        displayName: "Result Count",
        allowedContexts: ["InvoiceHistoryPage"],
    },
};

export default widgetModule;
